import { spacing } from 'styles/constants';
export const ORDER_CONTAINERS_SECTION_SPACING = spacing.$8;

export const geographicalFeeLabelIdMap = { CO: 'geographicalFeeCO' };

export enum MODAL_TYPE {
  SHOW_DETAILS = 'showDetails',
  TRACK_ORDER = 'trackOrder',
}
